import * as DropdownMenuRadix from "@radix-ui/react-dropdown-menu";
import React from "react";

type DropdownMenuWrapperProps = {
  triggerComponent: React.ReactNode;
  asChild?: boolean;
  sideOffset?: number;
  width?: number;
  fullWidth?: boolean;
  disabled?: boolean;
  container?: HTMLElement;
} & DropdownMenuRadix.DropdownMenuProps;

const DropdownMenu: React.FC<DropdownMenuWrapperProps> = ({
  triggerComponent,
  children,
  asChild = true,
  sideOffset = 5,
  width = 220,
  fullWidth = false,
  disabled = false,
  container,
  ...rest
}) => {
  return (
    <DropdownMenuRadix.Root {...rest}>
      <DropdownMenuRadix.Trigger
        asChild={asChild}
        style={{
          width: fullWidth ? "100%" : "auto",
        }}
        disabled={disabled}
      >
        {triggerComponent}
      </DropdownMenuRadix.Trigger>

      <DropdownMenuRadix.Portal container={container}>
        <DropdownMenuRadix.Content
          className="data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade shadow-dropdown-shadow z-[1007] flex min-w-[220px] flex-col rounded-md bg-white will-change-[opacity,transform]"
          sideOffset={sideOffset}
          collisionPadding={20}
          style={{
            width,
            zIndex: 1007,
          }}
        >
          {children}
        </DropdownMenuRadix.Content>
      </DropdownMenuRadix.Portal>
    </DropdownMenuRadix.Root>
  );
};

export default DropdownMenu;
